import {createStore} from 'vuex'
import axios from "axios";
import config from "../../../config/config.json";

export default createStore({
    state: {
    },
    getters: {},

    actions: {
        featCat: async ({commit}, data) => {
            return new Promise((resolve, reject) => {
                axios.get(config.BASE_URL + '/settings')
                    .then(function (res) {
                        return resolve(res.data.data.data);
                    })
                    .catch(function (errors) {
                        console.log(errors);
                    });
            });
        },
    },
    modules: {}
})
